export default __webpack_public_path__ + "static/BuildMissingMiddleHousing-89e18f515fa87d2375efb35d25ba5e61.jpg";